import { APIModel } from "app/state/api";
import { ApiCallModel } from "app/state/api/interfaces";

// main
export const ExplorerLocationFilterOptions: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/explorer/filter-options/locations`),
};

export const ExplorerPublisherFilterOptions: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/filter-options/publishers`
  ),
};

export const ExplorerSectorsFilterOptions: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/explorer/filter-options/sectors`),
};

export const ExplorerActivityStatusFilterOptions: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/filter-options/activity-status`
  ),
};

export const ExplorerYearFilterOptions: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/explorer/filter-options/years`),
};

export const ExplorerSDGFilterOptions: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/explorer/filter-options/sdgs`),
};

// activity

export const ExplorerActivityScopeFilterOptions: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/filter-options/activity-scope`
  ),
};

export const ExplorerDocumentLinkCategoryFilterOptions: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/filter-options/document-link-category`
  ),
};

export const ExplorerHierarchyFilterOptions: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/explorer/filter-options/hierarchy`),
};

export const ExplorerHumanitarianScopeVocabularyFilterOptions: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/filter-options/humanitarian-scope-vocabulary`
  ),
};

export const ExplorerHumanitarianScopeTypeFilterOptions: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/filter-options/humanitarian-scope-type`
  ),
};

export const ExplorerIATIVersionFilterOptions: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/filter-options/iati-version`
  ),
};

export const ExplorerOtherIdentifierTypeFilterOptions: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/filter-options/other-identifier-type`
  ),
};

export const ExplorerTagFilterOptions: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/explorer/filter-options/tag`),
};

// default

export const ExplorerDefaultAidTypeFilterOptions: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/filter-options/default-aid-type`
  ),
};

export const ExplorerDefaultAidTypeVocabularyFilterOptions: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/filter-options/default-aid-type-vocabulary`
  ),
};

export const ExplorerCurrencyFilterOptions: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/explorer/filter-options/currency`),
};

export const ExplorerDefaultFinanceTypeFilterOptions: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/filter-options/default-finance-type`
  ),
};

export const ExplorerDefaultFlowTypeFilterOptions: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/filter-options/default-flow-type`
  ),
};

export const ExplorerDefaultLanguageFilterOptions: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/filter-options/default-language`
  ),
};

export const ExplorerDefaultTiedStatusFilterOptions: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/filter-options/default-tied-status`
  ),
};

// organisation

export const ExplorerTransactionReceiverOrganisationFilterOptions: ApiCallModel =
  {
    ...APIModel(
      `${process.env.REACT_APP_API}/explorer/filter-options/transaction-receiver-organisation`
    ),
  };

export const ExplorerReportingOrganisationTypeFilterOptions: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/filter-options/reporting-organisation-type`
  ),
};

export const ExplorerCollaborationTypeFilterOptions: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/filter-options/collaboration-type`
  ),
};

// sector

export const ExplorerSectorVocabularyFilterOptions: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/filter-options/sector-vocabulary`
  ),
};

export const ExplorerPolicyMarkerFilterOptions: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/filter-options/policy-marker`
  ),
};

// transaction

export const ExplorerTransactionFlowTypeFilterOptions: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/filter-options/transaction-flow-type`
  ),
};

export const ExplorerTransactionTiedStatusFilterOptions: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/filter-options/transaction-tied-status`
  ),
};

export const ExplorerTransactionValueCurrencyFilterOptions: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/filter-options/transaction-value-currency`
  ),
};
